module.exports = __webpack_public_path__ + "img/step26_a_printer_basic_install_left_rear_cover.1d509f21.png";